import { IAnalyticsConfiguration } from '../../../../domain/analytics/analytics-configuration'
import { IPageConfiguration } from '../../../../domain/conf/page'

import { DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'
import { IdentityEvent, IIdentityEvent } from '../../../common/events/identity'
import { IKruxEvent, KruxEvent } from '../../../common/events/krux'
import { IAdServiceAdapter, ITagManagerAdapter, ITagManagerProviderConfig, TagManagerProvider } from '../adapter'
import { KruxUtils } from './utils/krux'

export interface IWindow extends Window {
    Krux: any
    KruxDataLayer: any
}

declare let window: IWindow

/**
 * NOTE: noticed a limitation with the trait/mixin strategy used here in that the first in a chain
 * needs to act on the top-most class, whereas successive need to act on their self class in order
 * to call supers.
 */
export const WithKrux = <T extends Mixin<IAdServiceAdapter>>(Base: T) =>
    class extends Base implements ITagManagerAdapter {
        private kruxJsPath = '//cdn.krxd.net/controltag/'

        /**
         * Loads JS library for given account.
         */
        public initializeTagManagers(confs: ITagManagerProviderConfig[], pageConf?: IPageConfiguration,
                                     analyticsConf?: IAnalyticsConfiguration) {

            // multiple providers are supported, so fetch conf by name
            const conf = confs && confs.find((_) => _.client === TagManagerProvider.KRUX)
            if (conf) {
                // setup global object
                if (!window.Krux) {
                    window.Krux = (args: any) => window.Krux.q.push(args)
                    window.Krux.q = []
                }

                // initiate KruxDataLayer
                if (!window.KruxDataLayer) {
                    window.KruxDataLayer = {}
                }

                // expose page data for Krux
                if (pageConf || analyticsConf) {
                    window.KruxDataLayer.data = KruxUtils.formatData(pageConf, analyticsConf)

                    // injecting mParticle ID into Krux data object
                    addEventListener(IdentityEvent.PROVIDER_ID_ASSIGNED, (e: IIdentityEvent) => {
                        if (e.detail.mpId) {
                            window.KruxDataLayer.data.MPID = e.detail.mpId
                        } else {
                            window.KruxDataLayer.data.MPID = undefined
                        }
                    })
                }

                // load JS
                DOMUtils.loadScript(`${this.kruxJsPath}${conf.account}.js`)
            }

            this.initializeEventListeners()
        }

        public initializeEventListeners() {
            // listen for any events for firing a pixel
            addEventListener(KruxEvent.FIRE_EVENT_PIXEL, (e: IKruxEvent) => {
                if (e.detail.kruxPixelId) {
                    const pixelUrl = `https://beacon.krxd.net/event.gif?` +
                        `event_id=${e.detail.kruxPixelId}&event_type=default`

                    const loadKrux = document.createElement('img')
                    loadKrux.setAttribute('src', pixelUrl)
                    loadKrux.setAttribute('width', '0')
                    loadKrux.setAttribute('height', '0')
                    document.body.appendChild(loadKrux)
                }
            })
        }
    }
